<form class="row" [formGroup]="form">
    <div class="col-12">
        @if (prgId === null) {
            <ui-form-select
                [label]="'global.labels.partner' | translate"
                [formControlName]="programSingleProductFormField.OrgId"
                [bindLabel]="'orgName'"
                [bindValue]="'orgId'"
                [clearable]="false"
                [options]="partners" />
        }

        <ui-form-input [label]="'global.forms.labels.name' | translate" [formControlName]="programSingleProductFormField.Name" />
    </div>
    @if (prgId === null) {
        <div class="col-12">
            <ui-form-group-wrapper [label]="'global.forms.labels.service' | translate" [required]="true">
                <ng-select
                    bindLabel="srvName"
                    bindValue="srvId"
                    [clearAllText]="'global.actions.clear' | translate"
                    [notFoundText]="'global.labels.no_items_found' | translate"
                    [readonly]="lyView"
                    [items]="services"
                    [searchable]="false"
                    [clearable]="false"
                    [ngClass]="'ng-select--form-control'"
                    (change)="handlerChangeService($event)" />
            </ui-form-group-wrapper>
        </div>
        <div class="col-12">
            <ui-form-select
                [label]="(prgTypeValue === b2bProgramTypeEnum.NumberOfTrips ? 'global.labels.tickets' : 'global.labels.ticket') | translate"
                [formControlName]="programSingleProductFormField.TrfId"
                [bindLabel]="'trfName'"
                [bindValue]="'trfId'"
                [clearable]="false"
                [options]="tickets" />
        </div>
    } @else {
        <div class="col-12">
            <ui-form-group-wrapper
                [label]="(prgTypeValue === b2bProgramTypeEnum.NumberOfTrips ? 'global.labels.tickets' : 'global.labels.ticket') | translate"
                [marginClass]="'mb-5'">
                <div class="w-100">
                    <span class="form-control__static-value">{{ trfName }}</span>
                </div>
            </ui-form-group-wrapper>
        </div>
    }

    <fieldset class="col-12 mb-8">
        <h3 class="mb-5">{{ 'global.labels.discount' | translate }}</h3>
        <div class="row mb-5">
            <div class="col-12">
                <label class="mb-1 label">
                    {{ 'data.period-insurance-types.current' | translate }}
                    @if (prgId === null) {
                        <sup>*</sup>
                    }
                </label>
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-select
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [options]="type"
                    [bindLabel]="'title'"
                    [bindValue]="'id'"
                    [formControlName]="programSingleProductFormField.CurrDiscountRateType"
                    [translateOptions]="true"
                    [clearable]="false"
                    [placeholder]="'global.labels.valueType' | translate" />
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-input
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [placeholder]="currDiscountRateType.value === b2bProgramRate.FixSum ? '0.00' : '0 - 100%'"
                    [formControlName]="programSingleProductFormField.CurrDiscountRate"
                    [pattern]="currDiscountRateType.value === b2bProgramRate.FixSum ? PATTERN_NUMERIC : PATTERN_PERCENTAGE"
                    [type]="'number'" />
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-select
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [options]="unit"
                    [bindLabel]="'title'"
                    [bindValue]="'id'"
                    [formControlName]="programSingleProductFormField.CurrDiscountUnitType"
                    [clearable]="false"
                    [translateOptions]="true"
                    [placeholder]="'global.labels.unitType' | translate" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label class="mb-1">
                    {{ 'data.period-insurance-types.next' | translate }}
                    @if (prgId === null) {
                        <sup>*</sup>
                    }
                </label>
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-select
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [options]="type"
                    [bindLabel]="'title'"
                    [bindValue]="'id'"
                    [formControlName]="programSingleProductFormField.NextDiscountRateType"
                    [clearable]="false"
                    [translateOptions]="true"
                    [placeholder]="'global.labels.valueType' | translate" />
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-input
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [placeholder]="nextDiscountRateType.value === b2bProgramRate.FixSum ? '0.00' : '0 - 100%'"
                    [formControlName]="programSingleProductFormField.NextDiscountRate"
                    [pattern]="nextDiscountRateType.value === b2bProgramRate.FixSum ? PATTERN_NUMERIC : PATTERN_PERCENTAGE"
                    [type]="'number'" />
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-select
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [options]="unit"
                    [bindLabel]="'title'"
                    [bindValue]="'id'"
                    [clearable]="false"
                    [formControlName]="programSingleProductFormField.NextDiscountUnitType"
                    [translateOptions]="true"
                    [placeholder]="'global.labels.unitType' | translate" />
            </div>

            <div class="col-12 col-md-6 mt-5">
                <ui-calendar-control
                    [label]="'global.forms.labels.dateFrom' | translate"
                    [required]="true"
                    [disabled]="lyView"
                    [formControlName]="programSingleProductFormField.NextDiscountDate" />
            </div>
        </div>
    </fieldset>

    <fieldset class="col-12">
        <h3 class="mb-5">{{ 'global.labels.fee' | translate }}</h3>
        <div class="row mb-5">
            <div class="col-12">
                <label class="mb-1 label">
                    {{ 'data.period-insurance-types.current' | translate }}
                    @if (prgId === null) {
                        <sup>*</sup>
                    }
                </label>
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-select
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [options]="type"
                    [bindLabel]="'title'"
                    [bindValue]="'id'"
                    [clearable]="false"
                    [formControlName]="programSingleProductFormField.CurrFeeRateType"
                    [translateOptions]="true"
                    [placeholder]="'global.labels.valueType' | translate" />
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-input
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [placeholder]="currFeeRateType.value === b2bProgramRate.FixSum ? '0.00' : '0 - 100%'"
                    [formControlName]="programSingleProductFormField.CurrFeeRate"
                    [pattern]="currFeeRateType.value === b2bProgramRate.FixSum ? PATTERN_NUMERIC : PATTERN_PERCENTAGE"
                    [type]="'number'" />
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-select
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [options]="unit"
                    [bindLabel]="'title'"
                    [bindValue]="'id'"
                    [clearable]="false"
                    [formControlName]="programSingleProductFormField.CurrFeeUnitType"
                    [translateOptions]="true"
                    [placeholder]="'global.labels.unitType' | translate" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label class="mb-1 label">
                    {{ 'data.period-insurance-types.next' | translate }}
                    @if (prgId === null) {
                        <sup>*</sup>
                    }
                </label>
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-select
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [options]="type"
                    [bindLabel]="'title'"
                    [bindValue]="'id'"
                    [clearable]="false"
                    [formControlName]="programSingleProductFormField.NextFeeRateType"
                    [translateOptions]="true"
                    [placeholder]="'global.labels.valueType' | translate" />
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-input
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [placeholder]="nextFeeRateType.value === b2bProgramRate.FixSum ? '0.00' : '0 - 100%'"
                    [formControlName]="programSingleProductFormField.NextFeeRate"
                    [pattern]="nextFeeRateType.value === b2bProgramRate.FixSum ? PATTERN_NUMERIC : PATTERN_PERCENTAGE"
                    [type]="'number'" />
            </div>
            <div class="col-12 col-lg-4">
                <ui-form-select
                    [additionalGroupClass]="'mb-lg-0 mb-5'"
                    [options]="unit"
                    [bindLabel]="'title'"
                    [bindValue]="'id'"
                    [clearable]="false"
                    [formControlName]="programSingleProductFormField.NextFeeUnitType"
                    [translateOptions]="true"
                    [placeholder]="'global.labels.unitType' | translate" />
            </div>

            <div class="col-12 col-md-6 mt-5">
                <ui-calendar-control
                    [label]="'global.forms.labels.dateFrom' | translate"
                    [required]="true"
                    [disabled]="lyView"
                    [formControlName]="programSingleProductFormField.NextFeeDate" />
            </div>
        </div>
    </fieldset>

    <ui-button-row [lyView]="lyView">
        @if (prgId === null) {
            <ui-button
                [size]="'lg'"
                [label]="'global.actions.add' | translate"
                [disabled]="form?.status === 'INVALID' || pending || !form.dirty"
                (handlerClick)="handlerAdd()" />
        } @else {
            <ui-button
                [size]="'lg'"
                [label]="'global.actions.save' | translate"
                [disabled]="form?.status === 'INVALID' || pending || !form.dirty"
                (handlerClick)="handlerEdit()" />
        }
    </ui-button-row>
</form>
